import * as React from 'react';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useField } from 'react-final-form';
import { getOrder, getIsBookedOrConfirmed, getBusinessRulesCheckboxMessages } from '../../../../../../store/order/selectors';
import FormControlLabel from '@mui/material/FormControlLabel';
import Tooltip from '../../../../../../../BaseComponents/Tooltip';
import Checkbox from '@mui/material/Checkbox';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../../../../theme';
import { useRenderers } from '../../../../../../../renderProps';
import { SafeHtml } from '@shared/ui';
import InfoLinksLabel from '../../../../../../../InfoLinksLabel';
let lastVisibleError = '';
const PassengersToolbarCheckbox = () => {
    const { t } = useTranslation('Checkout');
    const { PassengersToolbar: css } = useTheme('Checkout');
    const ref = React.useRef(null);
    const order = useSelector(getOrder);
    const isOrderBookedOrConfirmed = useSelector(getIsBookedOrConfirmed);
    const businessRulesCheckboxes = useSelector(getBusinessRulesCheckboxMessages);
    const additionalCheckboxes = [];
    const { renderCheckoutInfoLinksLabel: RenderCheckoutInfoLinksLabelOverride = InfoLinksLabel } = useRenderers();
    const { input, meta } = useField('terms', {
        type: 'checkbox',
        initialValue: false,
        validate: value => {
            if (!value) {
                return t('Please, read the rules of service and accept it');
            }
        }
    });
    useEffect(() => {
        // safari bug, when checkbox onBlur didn't fired
        // and form didn't update it's state
        input.onBlur();
    }, [input.value]);
    if (meta.error) {
        lastVisibleError = meta.error;
    }
    for (const infoMessageCheckbox of businessRulesCheckboxes) {
        additionalCheckboxes.push(useField(infoMessageCheckbox.code, {
            type: 'checkbox',
            initialValue: false,
            validate: value => (value ? undefined : t('Please, read the rules of service and accept it'))
        }));
    }
    const firstAdditionalError = additionalCheckboxes.find(field => !!field.meta.error);
    if (firstAdditionalError) {
        lastVisibleError = firstAdditionalError.meta.error;
    }
    const aggregatedTooltipOpen = useMemo(() => {
        if (meta.submitFailed && !input.value) {
            return true;
        }
        if (!!additionalCheckboxes.find(({ meta, input }) => meta.submitFailed && !input.value)) {
            return true;
        }
        return false;
    }, [meta.submitFailed, input, lastVisibleError]);
    return (React.createElement(React.Fragment, null, !isOrderBookedOrConfirmed && (React.createElement(React.Fragment, null,
        React.createElement(FormControlLabel, { ref: ref, classes: {
                root: css.root,
                label: css.label
            }, control: React.createElement(Tooltip, { open: aggregatedTooltipOpen, title: lastVisibleError, placement: "top-start", classes: {
                    popper: css.tooltip
                }, PopperProps: {
                    container: ref.current
                } },
                React.createElement(Checkbox, { color: "primary", classes: {
                        colorPrimary: css.checkbox,
                        checked: css.checkbox_checked
                    }, checked: input.checked, inputProps: Object.assign({}, input) })), label: React.createElement(RenderCheckoutInfoLinksLabelOverride, { order: order, type: "checkout" }) }),
        additionalCheckboxes.map((checkbox, index) => (React.createElement(FormControlLabel, { key: businessRulesCheckboxes[index].code, classes: {
                root: css.root,
                label: css.label
            }, control: React.createElement(Checkbox, { color: "primary", classes: {
                    colorPrimary: css.checkbox,
                    checked: css.checkbox_checked
                }, checked: checkbox.input.checked, inputProps: Object.assign({}, checkbox.input) }), label: React.createElement(SafeHtml, { tag: "p", html: businessRulesCheckboxes[index].text }) })))))));
};
export default PassengersToolbarCheckbox;
